<template>
  <div>
    <div v-html="pagecontent" />
  </div>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pagecontent: '',
    };
  },
  mounted() {
    this.pagecontent_callback();
  },
  methods: {
    pagecontent_callback() {
      this.pagecontent = window.atob(this.shopifyData.content);
    },
  },
};
</script>
